export default __webpack_public_path__ + "media/images/new_year/header_1280x840_2-0c79e7d7870af4f873fe1d4edcddb27f.jpg";